
var MyPlugin = {};
var baseUrl = 'http://conference2019.hanban.org/';

//var baseUrl = '';
MyPlugin.install = function (Vue) {
    // 1. 添加全局方法或属性
    Vue.prototype.baseUrl = baseUrl
    Vue.prototype.checkLogin = function () {
        var loginUrl = "/user/api/checkLogin";
        var promise = Vue.prototype.$utils.get(loginUrl,
            {
                withinfo: 1,
                hasentryform: 1,
                _: (new Date).getTime()
            })
        return promise
    }

 
    // 3. 注入组件选项
    Vue.mixin({ 
        created: function () {
            // 逻辑...
        }
    })
    var utils = {
        get: function (url, params) {
            if (url.charAt(0, 1) == '/') {
                url = url.substr(1, url.length - 1);
            }
            var promise = Vue.axios.get(baseUrl + url, {
                params: params,
            })
            return promise
        },
        post: function (url, params, config) {
            if (url.charAt(0, 1) == '/') {
                url = url.substr(1, url.length - 1);
            }
            var promise = Vue.axios.post(baseUrl + url, params, config)
            return promise
        }
    }

    // 4. 添加实例方法
    Vue.prototype.$utils = utils
}

export default MyPlugin